import { workspaceLayoutStore } from '@state/workspaceLayout/workspaceLayout.store';
import { useEffect } from 'react';

export const useReserveWorkspacePanel = (key: string, width: number) => {
  useEffect(() => {
    const { reserveRightPanel, releaseRightPanel } = workspaceLayoutStore.getState();

    if (width <= 0) {
      releaseRightPanel(key);
      return;
    }

    reserveRightPanel(key, width);

    return () => releaseRightPanel(key);
  }, [key, width]);
};
